import React, { useState, useEffect } from 'react';
import { FaFacebook, FaLinkedin, FaWhatsapp, FaTwitter } from 'react-icons/fa';
import Swal from 'sweetalert2';
// import { Helmet } from 'react-helmet';
// import { Helmet, HelmetProvider } from 'react-helmet-async';
// Import assets
import fluent_mdl2_embedIcon from '../../src/Assets/icon/fluent-mdl2_embed.png';
import whatsappIcon from '../../src/Assets/icon/logos_whatsapp-icon.png';
import linkedinIcon from '../../src/Assets/icon/image 14.png';
import xIcon from '../../src/Assets/icon/image 13.png';
import {SHARE_BASE_URL } from '../Api/config';
// Import configurations

const ShareTender = ({ isOpen, onClose, tender_id }) => {
  const [copied, setCopied] = useState(false);

  // console.log("tender id in share modal:", tender_id);

  // const tenderUrl = `${SHARE_BASE_URL}/viewTenderDetails/?tender_id=${tender_id}`;
  const tenderUrl = `${SHARE_BASE_URL}/view-tender-details/?tender_id=${tender_id}`;

  // Construct sharing URLs
  const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
    tenderUrl
  )}`;
  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    tenderUrl
  )}`;
  const whatsappUrl = `https://web.whatsapp.com/send?text=${encodeURIComponent(
    tenderUrl
  )}`;
  const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
    tenderUrl
  )}`;

  const handleCopyLink = () => {
    navigator.clipboard.writeText(tenderUrl).then(() => {
      setCopied(true); 
      setTimeout(() => setCopied(false), 10000);
    });
  };

  if (!isOpen) return null;

  return (
    <>
      {/* <HelmetProvider>
        <Helmet>
          <meta property="og:type" content="website" />
          <meta
            property="og:image"
            content={
              profileData?.profile_picture
                ? `${PHOTO_BASE_URL}${profileData.profile_picture}`
                : 'fallback-image-url'
            }
          />
          <meta
            property="og:title"
            content={profileData?.full_name || 'Tutorwise Premium Tutor'}
          />
          <meta
            property="og:description"
            content={profileData?.profile_headline || 'No headline available.'}
          />
          <meta property="og:url" content={tenderUrl} />
          <meta property="og:site_name" content="Tutorwise" />
        </Helmet>
      </HelmetProvider> */}

      <div
        className={`fixed inset-0 z-50 flex items-center justify-center transition-opacity duration-300 ${
          isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        } bg-black bg-opacity-5`}
      >
        <div
          className={`bg-white rounded-lg w-11/12 max-w-xl p-4 transform transition-transform duration-300 ${
            isOpen ? 'scale-100' : 'scale-95'
          }`}
        >
          <div className="flex justify-between items-center mb-2 lg:mb-4">
            <div></div>
            <span
              className="text-black text-2xl font-bold cursor-pointer hover:text-gray-600"
              onClick={onClose}
              aria-label="Close modal"
            >
              &times;
            </span>
          </div>
          <h2
            id="modal-title"
            className="text-lg md:text-2xl font-semibold text-center mb-8"
          >
            Share This Tender
          </h2>

          <h2 className="mb-4 md:mb-5">Share</h2>
          <div className="flex gap-4 justify-start mb-4">
            <button
              onClick={handleCopyLink}
              className="flex items-center gap-2 text-gray-700 hover:text-blue-600"
            >
              <img src={fluent_mdl2_embedIcon} alt="Embed Icon" />
            </button>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-gray-700 hover:text-green-600"
            >
              <img src={whatsappIcon} alt="WhatsApp Icon" className="w-16" />
            </a>
            <a
              href={linkedInUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-blue-700 hover:text-blue-600"
            >
              <img src={linkedinIcon} alt="LinkedIn Icon" className="w-14" />
            </a>
            <a
              href={twitterUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-gray-700 hover:text-blue-500"
            >
              <img src={xIcon} alt="Twitter Icon" className="w-14" />
            </a>
          </div>

          <div className="flex gap-0">
            <input
              type="text"
              value={tenderUrl}
              readOnly
              className="p-2 w-4/5 rounded-l-lg border border-gray-600"
            />
            <button
              onClick={handleCopyLink}
              className="bg-DefaultColor hover:bg-DefaultHoverColor text-white px-4 py-2 rounded-r-lg"
            >
              {copied ? 'Copied' : 'Copy'}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShareTender;
